import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../auth/AuthContext";
import GoogleSignIn from "../auth/GoogleSignIn";
import "./Signup.css";

export default function Register() {
  const { setUser } = useAuth(); // 👈 hook into AuthContext
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/auth/signup`,
        {
          email: form.email,
          password: form.password,
          displayName: form.name,
        }
      );

      const { token } = res.data;

      // update AuthContext
      setUser({ email: form.email, token });

      // persist token (use "token" key to match CreatePoll/Login)
      localStorage.setItem("token", token);

      setSuccess("Registration successful!");
    } catch (err) {
      console.error("Registration failed", err);
      setError("Registration failed. Please try again.");
    }
  };

  return (
    <div className="auth-container">
      <h2>Create an Account</h2>

      <form onSubmit={handleSubmit} className="auth-form">
        <input
          type="text"
          name="name"
          value={form.name}
          onChange={handleChange}
          placeholder="Name"
          required
        />
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          placeholder="Email"
          required
        />
        <input
          type="password"
          name="password"
          value={form.password}
          onChange={handleChange}
          placeholder="Password"
          required
        />
        <button type="submit">Signup</button>
      </form>

      {error && <p className="error-msg">{error}</p>}
      {success && <p className="success-msg">{success}</p>}

      <div className="divider">or</div>

      <div className="social-buttons">
        <GoogleSignIn />
      </div>
    </div>
  );
}
